const {colors} = require(`./${window.$environment.SERVICE_PROVIDER}/variables`);

/***
 * 
 * ToolTip
 * border color - TOOLTIP_BORDER
 * background: TOOLTIP_BACKGROUND
 * text color - TOOLTIP_COLOR
 */
const overrides = {
    MuiTooltip: {
        arrow: {
          "&:before": {
            border: `1px solid ${colors?.TOOLTIP_BORDER ? colors?.TOOLTIP_BORDER : colors.PRIMARY_CONTRAST}`,
            backgroundColor: colors?.TOOLTIP_BACKGROUND ? colors?.TOOLTIP_BACKGROUND : colors.MODAL_BACKGROUND,
          },
        },
        tooltip: {
          maxWidth: '180px',
          minWidth: '65px',
          width: 'max-content',
          backgroundColor: colors?.TOOLTIP_BACKGROUND ? colors?.TOOLTIP_BACKGROUND : colors.MODAL_BACKGROUND,
          color: colors?.TOOLTIP_COLOR ? colors?.TOOLTIP_COLOR : colors.INPUT_COLOR,
          textAlign: 'center',
          fontSize: '1rem',
          padding: '4px 8px',
          borderRadius: '2px',
          border: `solid 1px ${colors?.TOOLTIP_BORDER ? colors?.TOOLTIP_BORDER : colors.PRIMARY_CONTRAST}`,
        }
      },
};

export default overrides;